import React from 'react';
import { Progress, ProgressBar, LoadingContent, Styledfooter } from './LoadingBar.styled';
import { StyledHeader, HeaderImg } from '@components/Header/Header.styled';
import { AmplifyLogs, UIConstants } from '@constants';
import Link from '@components/Link/Link';
import Text from '@components/Text/Text';
import { useSelector } from 'react-redux';
import { selectProgressWidth } from '@store/loading/selectors';
import { MainContentWrapper } from '@app.styled';
import { useNavigate } from 'react-router-dom';

const LoadingBar: React.FC = () => {
    const width: string = useSelector(selectProgressWidth);

    const navigate = useNavigate();
    return (
        <MainContentWrapper data-testid="loadingBar">
            <StyledHeader id="loadingBarHeaderMain">
                <Link
                    onClick={() => navigate('/', { replace: true })}
                    data-testid="eagleIcon"
                    id="eagleIcon"
                    eventAttributes={AmplifyLogs.homeBtn}
                >
                    <HeaderImg src={UIConstants.icons.eagleIcon} />
                </Link>
            </StyledHeader>
            <LoadingContent id="loadingBarContent">
                <Text textVariant="h1">{UIConstants.loadingText}</Text>
                <Progress>
                    <ProgressBar style={{ width: width }} />
                </Progress>
            </LoadingContent>
            <Styledfooter id="loadingBarFooter" />
        </MainContentWrapper>
    );
};

export default LoadingBar;
